import styled from "styled-components";
import { shade } from "polished";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;

  svg {
    padding-bottom: 10px;
  }
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
`;

export { Container, Title };
